module.exports = __webpack_public_path__ + "static/media/path_puplisher2.738d2876.svg";